/** A share of a goal as a ring that fills clockwise from the top. */
export const ProgressRing = ({ share, size, stroke }: { share: number; size: number; stroke: number }) => {
  const radius = (size - stroke) / 2;
  const length = 2 * Math.PI * radius;
  const center = size / 2;

  return (
    <svg aria-hidden viewBox={`0 0 ${size} ${size}`} width={size} height={size} className="shrink-0">
      <circle cx={center} cy={center} r={radius} fill="none" stroke="var(--site-well)" strokeWidth={stroke} />
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke="var(--primary)"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray={length}
        strokeDashoffset={length * (1 - share)}
        transform={`rotate(-90 ${center} ${center})`}
      />
    </svg>
  );
};
